module.exports = __webpack_public_path__ + "img/guangfu.b3fa6b0b.png";